import React, { useEffect, useState } from 'react';
import useStyle from './menuBurgerIcon.style';
import { classNames } from '../../../../helpers/style/classNames';
import { useLocation } from 'react-router-dom';

export interface MenuBurgerIconProps {
  color?: string;
  defaultStatus?: boolean;
}

export const MenuBurgerIcon = ({
  defaultStatus = false
}: MenuBurgerIconProps) => {
  const classes = useStyle();
  const [status, setStatus] = useState(defaultStatus);
  const location = useLocation();

  useEffect(() => {
    setStatus(false);
  }, [location]);

  return (
    <div
      onClick={() => setStatus(!status)}
      className={classNames([classes.root, classes.normal])}
    >
      <span
        className={classNames(
          [classes.item],
          [
            {
              condition: status === true,
              classe: classes.active1
            }
          ]
        )}
      />
      <span
        className={classNames(
          [classes.item],
          [
            {
              condition: status === true,
              classe: classes.active2
            }
          ]
        )}
      />
      <span
        className={classNames(
          [classes.item],
          [
            {
              condition: status === true,
              classe: classes.active3
            }
          ]
        )}
      />
    </div>
  );
};
